import { CancelAttribution } from 'frontend/core/src/data/apis/types';

import { AttributionInfo } from './AttributionInfo';
import { CancelSourceBadge } from './SourceBadges';
import { ResolvePerson } from './useRunPersonResolver';

export function CancelInfo({
  cancelledBy,
  resolvePerson,
  teamId
}: {
  cancelledBy?: CancelAttribution;
  resolvePerson: ResolvePerson;
  teamId?: string;
}) {
  return (
    <AttributionInfo
      header='Cancel Info'
      attribution={cancelledBy}
      sourceBadge={cancelledBy && <CancelSourceBadge source={cancelledBy.source} />}
      resolvePerson={resolvePerson}
      teamId={teamId}
      data-test-id='sql-pipeline-run-details-cancel-info'
    />
  );
}
